import { useParams } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { getRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'
import { Row, Space, Typography } from 'antd'
import CsvDependencies from '../../../antd/vehicle/CsvDependencies'

const VehicleCSVDependencies = () => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    getVehicleDetails()
  }, [])

  const getVehicleDetails = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Vehicle Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(`/api/vehicles/vehicle_details/${vehicle}/`)
    if (res?.msg) {
      setError(res?.msg)
    } else {
      setVehicleDetails(res)
      setError('')
    }
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <div className="page vehicle-dependencies">
      <Row className="title">
        <Space size={'middle'}>
          <Typography.Title level={2}>CSV Dependencies</Typography.Title>
        </Space>
      </Row>
      <Row className="body">
        {error ? (
          error
        ) : (
          <CsvDependencies
            vehicleDetails={vehicleDetails}
            setVehicleDetails={setVehicleDetails}
          />
        )}
      </Row>
    </div>
  )
}

export default VehicleCSVDependencies
